import i18n from 'i18next';
import { constantStrings } from '../../constantStrings';

export const bbSuperAdmin = [i18n.t(constantStrings.bbSuperAdmin)];

export const clientDocumentAccessRoles = [
    i18n.t(constantStrings.bbSuperAdmin),
    i18n.t(constantStrings.bbVerifierAdmin),
    i18n.t(constantStrings.bbVerifier)
];

export const hasPermtoOpenDownloadCompanyDocs = [
    i18n.t(constantStrings.bbSuperAdmin),
    i18n.t(constantStrings.bbAdmin),
    i18n.t(constantStrings.companySuperAdmin),
    i18n.t(constantStrings.propertyAdmin),
    i18n.t(constantStrings.propertyUser),
    i18n.t(constantStrings.propertyReadOnlyUser),
    i18n.t(constantStrings.bbVerifierAdmin),
    i18n.t(constantStrings.bbVerifier)
];
export const hasPermissiontoAccessCompanyFilesFolders = [
    i18n.t(constantStrings.bbSuperAdmin),
    i18n.t(constantStrings.bbAdmin),
    i18n.t(constantStrings.companySuperAdmin),
    i18n.t(constantStrings.propertyAdmin)
];

export const hasPermtoOpenDownloadVerifierDocs = [
    i18n.t(constantStrings.bbSuperAdmin),
    i18n.t(constantStrings.bbVerifierAdmin),
    i18n.t(constantStrings.bbVerifier)
];

export const documentsTypes: any = {
    boma: 'BOMA',
    client: 'Client',
    verifier: 'Verifier'
};

export const documentHeading = {
    [documentsTypes.boma]: i18n.t(constantStrings.bomaDocuments),
    [documentsTypes.client]: i18n.t(constantStrings.companyDocuments),
    [documentsTypes.verifier]: i18n.t(constantStrings.verifierDocuments)
};

export const actionDirectoriesUrl = {
    [documentsTypes.boma]: '/boma-directories/',
    [documentsTypes.client]: '/client-directories/',
    [documentsTypes.verifier]: '/verifier-directories/'
};

export const actionFilesUrl = {
    [documentsTypes.boma]: '/boma-files/',
    [documentsTypes.client]: '/client-files/',
    [documentsTypes.verifier]: '/verifier-files/'
};

export const documentTypeBasedOnurl: any = {
    '/boma-directories/': documentsTypes.boma,
    '/client-directories/': documentsTypes.client,
    '/verifier-directories/': documentsTypes.verifier
};
